import { FetchApi } from '../lib/anuket-http';
import { configs } from '../configs';
import { getToken } from '../utils/isLoggedIn';
import { streamHook, streamFail, eventBus } from './Streams';

const unofficialStream = 'unofficial-event-results-stream';
const unofficialStreamFetching = 'unofficial-event-results-fetching';
const saveUnofficialStream = 'saveUnofficial';

/**
 * Get all unofficial results
 * @param event
 * @returns {*}
 */
export function getUnofficialResults( event ){

  const eventUrl = `${configs.ATHLINKS_API_HOST}/Events/Race/Api/${event}/Unofficial`;
  eventBus.publish(unofficialStreamFetching, {fetching: true});
  streamFail(
    unofficialStream,
    FetchApi
      .doFetch(eventUrl, {})
      .map(({ Result }) => Result.AthleteWaitList),
    ((msg) => {eventBus.publish(unofficialStreamFetching, {fetching: false}); return msg;})
  );

  return streamHook(unofficialStream);
}


/**
 * Save new entry for unofficial result
 * @param eventID
 * @param SelectedCourseId
 * @param UnofficialTime
 * @param ResultLink
 * @returns {*}
 */
export async function saveUnofficialResult( eventID, {SelectedCourseId, UnofficialTime, Url} ) {
  const token = await getToken();
  const url = `${configs.ATHLINKS_API_HOST}/Events/Race/Api/${eventID}/Unofficial/Save`;
  streamFail(
    saveUnofficialStream,
    FetchApi.doFetch(
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          SelectedCourseId,
          UnofficialTime,
          Url
        })
      }
    ),
    (x) => console.log(x) || x
  );
  return streamHook(saveUnofficialStream);
}

/**
 *
 * Remove event from calendar for authorized user
 *
 * @param eventId
 * @returns {*}
 */
export async function removeUnofficialResult(eventId) {
  const token = await getToken();
  const url = `${configs.ATHLINKS_API_HOST}/Events/Race/Api/${eventId}/Unofficial/Remove`;
  return FetchApi.doFetch(
    url,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }
  );
}



/**
 * Sets result container title
 * @param eventCourseId
 * @param results
 */
export function setResultContainerTitle(eventCourseId, results) {
  if(eventCourseId && results && results.length > 0){
    eventBus.publish('result-page-title', true);
  } else {
    eventBus.publish('result-page-title', false);
  }
}

/**
 * Get result container title
 * @return {*}
 */
export function getResultContainerTitle() {
  return streamHook('result-page-title', true);
}

export function friendsUnofficialFunc(unofficial, friends){
  return unofficial.map((u) => {
    if(u.unofficial){
      u.unofficial = u.unofficial.filter(({RacerId}) => friends && friends.includes(RacerId));
      return u;
    } else if(friends.includes(u.RacerId)){
      return u;
    } else {
      return 0;
    }
  });
}



/** WEBPACK FOOTER **
 ** ./data/UnofficialResultsStream.js
 **/